"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modal = exports.modal_io = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const widget_1 = require("../basics/widget");
const Modal = (props) => {
    const ref = (0, react_1.useRef)(document.createElement('div'));
    (0, react_1.useEffect)(() => {
        props.modal_root.appendChild(ref.current);
        return () => {
            props.modal_root.removeChild(ref.current);
        };
    }, []);
    return (0, react_dom_1.createPortal)(props.inner_widget(props.input).run((o) => props.on_done(o)), ref.current);
};
/**
 * This is the lifted version of [[modal]]
 * This means instead of operating on a [Widget], it operates on an [[IOWidget]]
 */
const modal_io = (modal_root_id) => {
    const modal_root = document.getElementById(modal_root_id);
    return (inner_widget) => (input) => modal_root === null
        ? (0, widget_1.nothing)()
        : (0, widget_1.fromJSX)((on_done) => (react_1.default.createElement(Modal, { modal_root: modal_root, input: input, inner_widget: inner_widget, on_done: on_done })));
};
exports.modal_io = modal_io;
/**
 * It allows you to mount a given `widget` to be rendered in a different place inside the DOM than its parent widget.
 * Underneath it uses the similar in-purpose `ReactDOM.createPortal`.
 * @param modal_root_id
 */
const modal = (modal_root_id) => (widget) => (0, exports.modal_io)(modal_root_id)(() => widget)({});
exports.modal = modal;
